import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Icon } from '@iconify-icon/react';
import { ActionIcon } from '@mantine/core';
import TextInput from './TextInput';
const ControlledTextInput = ({ name, readOnly, rightSection, errorEnabled = true, control: controlProp, ...props }) => {
    console.log(`[ControlledTextInput] "${name}" - Starting render`);
    // Try to get form context, but handle SSR gracefully
    let ctx;
    try {
        ctx = useFormContext();
        console.log(`[ControlledTextInput] "${name}" - Got context:`, !!ctx);
        console.log(`[ControlledTextInput] "${name}" - Context control:`, !!ctx?.control);
    }
    catch (e) {
        console.error(`[ControlledTextInput] "${name}" - Context error:`, e);
        // Context not available (SSR or outside FormProvider)
        ctx = null;
    }
    const effectiveControl = ctx?.control ?? controlProp;
    console.log(`[ControlledTextInput] "${name}" - Effective control:`, !!effectiveControl);
    console.log(`[ControlledTextInput] "${name}" - Control prop:`, !!controlProp);
    if (!effectiveControl) {
        console.warn(`[ControlledTextInput] "${name}" - NO CONTROL! Rendering uncontrolled fallback.`);
        return _jsx(TextInput, { ...props, readOnly: readOnly, rightSection: rightSection });
    }
    console.log(`[ControlledTextInput] "${name}" - Using controlled mode with useController`);
    const { field, fieldState } = useController({ name, control: effectiveControl });
    const [showPassword, setShowPassword] = useState(false);
    const isLoading = ctx?.formState?.isLoading ?? false;
    const isSubmitting = ctx?.formState?.isSubmitting ?? false;
    const error = useMemo(() => (errorEnabled ? props.error || fieldState.error?.message || '' : ''), [errorEnabled, fieldState.error?.message, props.error]);
    const isFieldReadOnly = readOnly || isLoading || isSubmitting;
    return (_jsx(TextInput, { ...props, name: name, value: field.value ?? '', onChange: (e) => {
            field.onChange(e.target.value);
        }, onBlur: field.onBlur, ref: field.ref, error: error, "aria-invalid": !!fieldState.error, readOnly: isFieldReadOnly, type: props.type === 'password' ? (showPassword ? 'text' : 'password') : props.type, classNames: {
            label: 'text-sm text-gray-800 font-medium placeholder:text-red-500',
            error: 'text-red-500 text-xs',
            ...props.classNames,
        }, rightSection: rightSection ||
            (props.type === 'password' ? (_jsx(ActionIcon, { variant: "transparent", size: 20, onClick: () => setShowPassword(!showPassword), children: _jsx(Icon, { icon: showPassword ? 'tabler:eye' : 'tabler:eye-off', width: 20, className: "text-gray-500" }) })) : undefined) }));
};
export default ControlledTextInput;
